import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { reset } from '../../utils/styled-reset';
import { Icon } from '../icon/icon';

const ChooseIntegration = () => {
  const { t } = useTranslation('integrations');
  const addIntegrationLabel = t('integrationList.addIntegration', { ns: 'integrations' });

  return (
    <Component>
      <Content>
        <Icon color="#adadad" icon={'puzzle-piece'} size="9x" />
        <Text titleText={true} topMargin={true}>
          {t('integrationList.chooseTitle', { ns: 'integrations' })}
        </Text>
        <Text bottomMargin={true}>
          <Trans
            components={{
              bold: <strong />,
            }}
            i18nKey="integrationList.chooseDescription"
            ns="integrations"
            values={{
              addIntegration: addIntegrationLabel,
            }}
          />
        </Text>
      </Content>
    </Component>
  );
};

const Text = styled.span<{
  titleText?: boolean;
  topMargin?: boolean;
  bottomMargin?: boolean;
}>`
  display: block;

  font-weight: ${(props) => (props.titleText ? 200 : 300)};
  font-size: ${(props) => (props.titleText ? '1.5em' : '1.0em')};

  line-height: 1.5em;
  margin-top: ${(props) => (props.topMargin ? '0.5em' : undefined)};
  margin-bottom: ${(props) => (props.bottomMargin ? '0.5em' : undefined)};
`;

const Content = styled.div`
  display: flex;
  width: 350px;

  gap: 4px;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Component = styled.div`
  ${reset}
  font-size: 14px;

  display: grid;
  place-content: center;
  height: 100%;
`;

export { ChooseIntegration };
